export default __webpack_public_path__ + "static/media/discover-dark.4c8d7d9f.svg";